import React, { FC } from 'react';
import styled from 'styled-components';
import colors from 'const/style/colors';
import Spinner from './Spinner';

interface ILoadingProps {
  visible?:boolean;
}

const LoadingFrame = styled.div`
  position: fixed;
  width:100%;
  height:100%;
  background:#F0F3FA;
  z-index:999;
  top:0;
  left:0;
  display:flex;
  flex-direction:row;
  justify-content:center;
  align-items:center;
  .frame-spinner {
    counter-reset: circle;
    width:74px;
    height:28px;
    display:flex;
    flex-direction:row;
    justify-content:space-around;
    align-items:center;
    *[class^=circle] {
      counter-increment: circle;
      position:relative;
      width:10px;
      height:100%;
      transform:translateY(100%);
      animation: loading 1s ease infinite;
      animation-delay: calc(counter(circle) * 0.5s);
      &:before {
        content:' ';
        position:absolute;
        top:0;
        left:0;
        width: 10px;
        height: 10px;
        background:${colors.C2CBFA3CC};
        border-radius:10px;
      }
      &:nth-child(1) { animation-delay: calc( 1 * 0.1s); &:before {background-color:#06D586;} }
      &:nth-child(2) { animation-delay: calc( 2 * 0.1s); &:before {background-color:#0ACC92;} }
      &:nth-child(3) { animation-delay: calc( 3 * 0.1s); &:before {background-color:#11C19D;} }
      &:nth-child(4) { animation-delay: calc( 4 * 0.1s); &:before {background-color:#18B8A9;} }
      &:nth-child(5) { animation-delay: calc( 5 * 0.1s); &:before {background-color:#22A5C1;} }
    }
  }
  @keyframes loading {
    0% {transform: translateY(100%)}
    80% {transform: translateY(0%)}
    100% {transform: translateY(100%)}
  } 
`;

const Loading:FC<ILoadingProps> = ({ visible = true }) => (visible
  ? (
    <LoadingFrame>
      <Spinner></Spinner>
      {/* <div className='frame-spinner'>
        <div className='circle-0' />
        <div className='circle-1' />
        <div className='circle-2' />
        <div className='circle-3' />
        <div className='circle-4' />
      </div> */}
    </LoadingFrame>
  )
  : <></>);


export default Loading;
